import { render, staticRenderFns } from "./FFStepupRootComponent.vue?vue&type=template&id=bd9896ee&scoped=true"
import script from "./FFStepupRootComponent.vue?vue&type=script&lang=js"
export * from "./FFStepupRootComponent.vue?vue&type=script&lang=js"
import style0 from "./FFStepupRootComponent.vue?vue&type=style&index=0&id=bd9896ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9896ee",
  null
  
)

export default component.exports